var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 195,
    height: 30,
    viewBox: "0 0 195 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 77"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M167.041 0H173.211L180.69 11.4523L188.543 0H194.807L183.261 16.9213L183.226 26.2264C183.219 27.8787 181.878 29.215 180.226 29.215H178.072V16.9213L167.041 0Z",
    fill: "#1A202C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M134.12 0H161.902V2.14183C161.902 3.79869 160.559 5.14183 158.902 5.14183H153.021V26.215C153.021 27.8718 151.677 29.215 150.021 29.215H147.832L147.879 5.14183H134.12V0Z",
    fill: "#1A202C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M96.8433 0.09375H122.31C123.967 0.09375 125.31 1.4369 125.31 3.09375V5.28233H96.8433C96.1889 5.28233 95.6279 5.51604 95.1605 5.98348C94.693 6.45092 94.4593 7.01185 94.4593 7.66627C94.4593 8.63231 94.693 9.34905 95.1605 9.81649C95.6279 10.2839 96.1889 10.5176 96.8433 10.5176H119.561C122.147 10.5176 124.36 11.4369 126.198 13.2755C128.037 15.1141 128.956 17.3267 128.956 19.9132C128.956 22.4997 128.037 24.7122 126.198 26.5508C124.36 28.3894 122.147 29.3087 119.561 29.3087H93.6263C91.9695 29.3087 90.6263 27.9656 90.6263 26.3087V24.1201H119.561C120.714 24.1201 121.695 23.715 122.506 22.9048C123.316 22.0634 123.721 21.0662 123.721 19.9132C123.721 18.7602 123.316 17.7785 122.506 16.9683C121.695 16.1269 120.714 15.7062 119.561 15.7062H96.8433C94.7554 15.7062 92.9635 14.9739 91.4677 13.5093C90.0031 12.0135 89.2708 10.2216 89.2708 8.13371C89.2708 5.73418 90.0031 3.8021 91.4677 2.33746C92.9635 0.841653 94.7554 0.09375 96.8433 0.09375Z",
    fill: "#1A202C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M71.7533 0.187012C75.7421 0.187012 79.17 1.62049 82.037 4.48745C84.9039 7.32325 86.3374 10.7511 86.3374 14.7711C86.3374 18.7911 84.9039 22.2346 82.037 25.1015C79.17 27.9373 75.7421 29.3552 71.7533 29.3552H46.2853C42.2653 29.3552 38.8218 27.9373 35.9549 25.1015C33.1191 22.2346 31.7012 18.7911 31.7012 14.7711C31.7012 10.7511 33.1191 7.32325 35.9549 4.48745C38.8218 1.62049 42.2653 0.187012 46.2853 0.187012H71.7533ZM71.7533 24.1666C74.3086 24.1666 76.5056 23.2473 78.3442 21.4088C80.214 19.5702 81.1488 17.3576 81.1488 14.7711C81.1488 12.1846 80.214 9.97207 78.3442 8.13348C76.5056 6.29489 74.3086 5.37559 71.7533 5.37559H46.2853C43.6988 5.37559 41.4862 6.29489 39.6476 8.13348C37.809 9.97207 36.8897 12.1846 36.8897 14.7711C36.8897 17.3576 37.809 19.5702 39.6476 21.4088C41.4862 23.2473 43.6988 24.1666 46.2853 24.1666H71.7533Z",
    fill: "#1A202C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 66",
    d: "M5 15L5 14C5 12.3431 6.34315 11 8 11L24 11L24 15L5 15Z",
    fill: "#1A202C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 65",
    d: "M23.1661 0H25.0432C26.7001 0 28.0432 1.34315 28.0432 3V29.2626H23.1661V0Z",
    fill: "#1A202C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 67",
    d: "M0 0H1.8771C3.53396 0 4.8771 1.34315 4.8771 3V29.2626H0V0Z",
    fill: "#1A202C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.738de6f41ea3eeca06b47c89e3ca6154.svg";
export { ForwardRef as ReactComponent };